import events from 'eventslibjs';

const checkoutSubmit = () => {


  const checkoutBtn = document.querySelector('[name="woocommerce_checkout_place_order"]');

  if(checkoutBtn) {

    const checkoutBtnWrapper = checkoutBtn.closest('.wc-gzd-order-submit');
    if(checkoutBtnWrapper) {
      checkoutBtnWrapper.style.display = 'none';
      checkoutBtnWrapper.classList.add('is-hidden');
    }

    events.on('change', '[name="woocommerce_gzdp_checkout_final_step"]', (e) => {
      e.preventDefault();
      checkoutBtn.click();
    });

  }

}

checkoutSubmit();
